export const baseHrefConfig = {
    availableBases: ['/'],
    availableLocales: [
        'ru',
        'es',
        'de',
        'fr',
        'ja',
        'it',
        'pt-br',
        'da',
        'id',
        'ms',
        'nl',
        'no',
        'pl',
        'sv',
        'ko',
        'zh-cn',
        'zh-tw',
        'cs',
        'ro',
        'el',
        'et',
        'hu',
        'lt',
        'tr',
        'fi',
        'ar',
        'he',
    ],
    defaultLocale: 'en',
};
